import type { DashboardMetadataResource } from "@/types_api/backend/transport/dashboard_layout_response"
import type { DateRangePreset } from "@/utils/date/dateRangeTypes"

import type { DashboardDatePreferences } from "../types/dashboardConfig"

type DashboardDatePreferencesResource = NonNullable<
  NonNullable<DashboardMetadataResource["config"]>["date_preferences"]
>

const VALID_RELATIVE_UNITS = new Set(["days", "weeks", "months"])

function isRelativeUnit(
  value: string,
): value is DashboardDatePreferences["relativeConfig"] extends {
  unit: infer Unit
}
  ? Extract<Unit, string>
  : never {
  return VALID_RELATIVE_UNITS.has(value)
}

export function mapTransportDatePreferences(
  preferences?: DashboardDatePreferencesResource | null,
): DashboardDatePreferences | undefined {
  if (!preferences) {
    return undefined
  }

  const preset = preferences.preset as DateRangePreset | null | undefined
  const relativeConfig = preferences.relative_config

  return {
    preset: preset ?? undefined,
    customRange: preferences.custom_range ?? undefined,
    relativeConfig:
      relativeConfig && isRelativeUnit(relativeConfig.unit)
        ? {
            amount: relativeConfig.amount,
            unit: relativeConfig.unit,
          }
        : undefined,
  }
}
